module.exports = __webpack_public_path__ + "img/progress.8b1b9149.png";